import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Alert,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { getAdminProfile, updateAdminProfile } from "../../slices/thunks";
import avatar from "../../assets/images/users/avatar-1.jpg";
import { createSelector } from "reselect";
import { toast } from "react-toastify";

const UserProfile = () => {
  const dispatch = useDispatch();

  const selectProfileState = (state) => state;

  const profileSelector = createSelector(selectProfileState, (state) => ({
    user: state.Aprofile.user,
    loading: state.Aprofile.loading,
    error: state.Aprofile.error,
  }));

  const { user, loading, error } = useSelector(profileSelector);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobileNo: "",
    address: "",
  });

  const [originalData, setOriginalData] = useState({});

  useEffect(() => {
    const authUser = sessionStorage.getItem("authUser");
    if (authUser) {
      const parsed = JSON.parse(authUser);
      dispatch(getAdminProfile(parsed.data.id));
    }
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      const data = {
        name: user.name || "",
        email: user.email || "",
        mobileNo: user.mobileNo || "",
        address: user.address || "",

        profilePic: user.profilePic || "",
      };

      setFormData(data);
      setOriginalData(data);
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const changes = {};
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== originalData[key]) {
        changes[key] = formData[key];
      }
    });

    if (Object.keys(changes).length === 0) {
      toast.info("No changes made.");
      return;
    }

    const authUser = sessionStorage.getItem("authUser");

    if (authUser) {
      const parsed = JSON.parse(authUser);

      const queryPayload = {
        id: parsed.data.id,
        name: formData.name,
        email: formData.email,
        mobileNo: formData.mobileNo,
        address: formData.address,
      };

      const imageFormData = new FormData();
      if (formData.profilePicFile) {
        imageFormData.append("adminProfilePic", formData.profilePicFile);
      }

      dispatch(updateAdminProfile(queryPayload, imageFormData))
        .then((res) => {
          dispatch(getAdminProfile(parsed.data.id));
        })
        .catch((err) => {
          toast.error("Update failed. Please try again.");
        });
    }
  };

  document.title = "Admin Profile";

  return (
    <div className="page-content mt-lg-5">
      <Container fluid>
        <Row>
          <Col lg="12">
            {error && <Alert color="danger">{error}</Alert>}
            <Card>
              <CardBody>
                <Row>
                  <Col
                    md="4"
                    className="text-center border-end position-relative"
                  >
                    <div
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <img
                        src={formData.profilePic || avatar}
                        alt="avatar"
                        className="rounded img-thumbnail mb-3"
                        style={{
                          width: "160px",
                          height: "160px",
                          objectFit: "cover",
                          border: "2px solid #f0f0f0",
                        }}
                      />

                      <label
                        htmlFor="profilePicUpload"
                        style={{
                          position: "absolute",
                          bottom: "10px",
                          right: "10px",
                          backgroundColor: "#0d6efd",
                          borderRadius: "50%",
                          width: "36px",
                          height: "36px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                        }}
                      >
                        <i
                          className="ri-pencil-line text-white"
                          style={{ fontSize: "16px" }}
                        ></i>
                      </label>

                      <input
                        type="file"
                        id="profilePicUpload"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                              setFormData((prev) => ({
                                ...prev,
                                profilePic: reader.result,
                                profilePicFile: file,
                              }));
                            };

                            //   setFormData((prev) => ({
                            //     ...prev,
                            //     profilePic: reader.result,
                            //   }));
                            //   setProfilePicFile(file);
                            // };
                            reader.readAsDataURL(file);
                          }
                        }}
                      />
                    </div>

                    <h5 className="mt-2">{formData?.name}</h5>
                    <p className="text-muted mb-0">{formData?.email}</p>
                  </Col>

                  <Col
                    md="8"
                    className="d-flex align-items-center justify-content-center"
                  >
                    <div style={{ width: "70%" }}>
                      <Form onSubmit={handleSubmit}>
                        <FormGroup>
                          <Label>Name</Label>
                          <Input
                            type="text"
                            name="name"
                            value={formData?.name}
                            onChange={handleChange}
                          />
                        </FormGroup>

                        <FormGroup>
                          <Label>Email</Label>
                          <Input
                            type="email"
                            name="email"
                            value={formData?.email}
                            onChange={handleChange}
                          />
                        </FormGroup>

                        <FormGroup>
                          <Label>Mobile No</Label>
                          <Input
                            type="text"
                            name="mobileNo"
                            value={formData?.mobileNo}
                            onChange={handleChange}
                          />
                        </FormGroup>

                        <FormGroup>
                          <Label>Address</Label>
                          <Input
                            type="text"
                            name="address"
                            value={formData?.address}
                            onChange={handleChange}
                          />
                        </FormGroup>

                        <div className="text-center mt-3">
                          <Button
                            color="success"
                            className="btn-sm "
                            type="submit"
                          >
                            Update Profile
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UserProfile;
